import { graphql } from "~/gql";

export const CREATE_AND_ADD_TECHNOLOGY_CHARGE = graphql(/* GraphQL */ `
  mutation createAndAddTechnologyCharge($data: TechnologyChargeCreateInput!) {
    createAndAddTechnologyCharge(data: $data) {
      ...TechnologyChargeParts
    }
  }
`);
